<app-header *ngIf="!isHomePage"></app-header>
<router-outlet></router-outlet>
<app-footer [mailText]="mail_text"></app-footer>
